import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin/users')({
    component: AdminUsersLayout,
})

function AdminUsersLayout() {
    return <Outlet />
}
